import { useEffect, useState } from "react";
import netlifyIdentity from "../identity";

export default function Login() {
  const [loading, setLoading] = useState(true);
  const [me, setMe] = useState(null);

  useEffect(() => {
    const current = netlifyIdentity.currentUser();
    setMe(current || null);
    setLoading(false);

    const onLogin = (user) => {
      setMe(user);
      window.location.href = "/admin";
    };
    const onLogout = () => setMe(null);

    netlifyIdentity.on("login", onLogin);
    netlifyIdentity.on("logout", onLogout);
    return () => {
      netlifyIdentity.off("login", onLogin);
      netlifyIdentity.off("logout", onLogout);
    };
  }, []);

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logoCircle}>🔐</div>
        <h1 style={styles.title}>Admin Login</h1>
        <p style={styles.subtitle}>
          Only authorized administrators can access the console.
        </p>

        {loading ? (
          <div style={styles.note}>Checking session…</div>
        ) : me ? (
          <div style={{ marginTop: 12 }}>
            <div style={styles.badge}>
              Logged in as <strong style={{ marginLeft: 6 }}>{me.email}</strong>
            </div>
            <div style={{ display: "flex", gap: 10, marginTop: 16 }}>
              <button
                className="btn btn-primary"
                onClick={() => (window.location.href = "/admin")}
              >
                Go to Admin
              </button>
              <button className="btn" onClick={() => netlifyIdentity.logout()}>
                Logout
              </button>
              <button
                className="btn"
                onClick={() => netlifyIdentity.open("account")}
              >
                Account
              </button>
            </div>
          </div>
        ) : (
          <div style={{ marginTop: 12 }}>
            <button
              className="btn btn-primary"
              onClick={() => netlifyIdentity.open()}
              style={styles.ctaBtn}
            >
              Login with Email
            </button>
            <div style={styles.note}>
              Tip: Keep your email open—after verification you’ll be redirected
              to the admin page.
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "grid",
    placeItems: "center",
    padding: 20,
    background:
      "radial-gradient(1200px 500px at 10% -10%, #f1f6ff, transparent), radial-gradient(1200px 500px at 110% 110%, #f7f9ff, transparent)",
  },
  card: {
    width: "100%",
    maxWidth: 430,
    background: "#fff",
    border: "1px solid #e8e8e8",
    borderRadius: 16,
    padding: "28px 24px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
    textAlign: "center",
  },
  logoCircle: {
    width: 64,
    height: 64,
    borderRadius: "50%",
    display: "grid",
    placeItems: "center",
    fontSize: 28,
    margin: "0 auto 10px",
    background: "#eef3ff",
  },
  title: { margin: "8px 0 4px", fontSize: 24 },
  subtitle: { color: "#666", margin: 0 },
  ctaBtn: {
    padding: "10px 18px",
    fontWeight: 600,
    width: "100%",
    marginTop: 6,
  },
  badge: {
    display: "inline-block",
    background: "#f5f7ff",
    border: "1px solid #e5e9ff",
    padding: "8px 12px",
    borderRadius: 10,
  },
  note: { fontSize: 13, color: "#6f6f6f", marginTop: 10 },
};
